import {MenuCreateOptionInterface} from "kernel/types/module";

class menu {
  private vm: Vue
  constructor() {
    this.vm = window.rootVm
  }

  $t(args: string) {
    if (!this.vm) return args
    return this.vm.$t(args)
  }

  get() : {[key: string]: any} {
    return {
      admin: [
        {
          create: (options: MenuCreateOptionInterface ) => options.hasRole(['ROLE_ADMIN', 'ROLE_MEMBER', 'ROLE_PROVIDER', 'ROLE_STORE']),
          label: '會員管理',
          icon: 'fa fa-users',
          order: 6, // 確保排在 OTP (order: 5) 之後，contact 之前
          group: [
            {
              label: this.$t('page.member'),
              create: (options: MenuCreateOptionInterface ) => options.hasRole(['ROLE_ADMIN', 'ROLE_MEMBER']),
              route: {
                name: 'member',
              },
            },
            {
              label: this.$t('page.provider'),
              create: (options: MenuCreateOptionInterface ) => options.hasRole(['ROLE_PROVIDER']),
              route: {
                name: 'provider',
              },
            },
            {
              label: this.$t('page.store'),
              create: (options: MenuCreateOptionInterface ) => options.hasRole(['ROLE_STORE']),
              route: {
                name: 'store',
              },
            },
          ],
        },
      ],
    }
  }
}

export default () => (new menu()).get()
